import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EMAIL_JS_SERVICE_ID, EMAIL_JS_TEMPLATE_ID, EMAIL_JS_PUBLIC_KEY } from "../constants";
import Footer from "./Footer";
import LiquidEther from './LiquidEther';
import './styles/Contact.css';

const Contact = () => {
    const formRef = useRef();
    const contactRef = useRef(null);
    const [form, setForm] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const contact = contactRef.current;
        if (!contact) return;

        const handleMouseMove = (e) => {
            const rect = contact.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            
            // Update filter turbulence based on mouse position
            const filter = document.querySelector('#glass-distortion-contact feDisplacementMap');
            if (filter) {
                const scaleX = (x / rect.width) * 100;
                const scaleY = (y / rect.height) * 100;
                filter.setAttribute('scale', Math.min(scaleX, scaleY));
            }
            
            // Add highlight effect
            const specular = contact.querySelector('.glass-specular');
            if (specular) {
                specular.style.background = `radial-gradient(
                    circle at ${x}px ${y}px,
                    rgba(255,255,255,0.15) 0%,
                    rgba(255,255,255,0.05) 30%,
                    rgba(255,255,255,0) 60%
                )`;
            }
        };

        const handleMouseLeave = () => {
            const filter = document.querySelector('#glass-distortion-contact feDisplacementMap');
            if (filter) {
                filter.setAttribute('scale', '77');
            }
            
            const specular = contact.querySelector('.glass-specular');
            if (specular) {
                specular.style.background = 'none';
            }
        };

        contact.addEventListener('mousemove', handleMouseMove);
        contact.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            contact.removeEventListener('mousemove', handleMouseMove);
            contact.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, []);

    const handleChange = (e) => {
        const { target } = e;
        const { name, value } = target;

        setForm({
            ...form,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const username = form.name.trim();
        const user_email = form.email.trim();
        const user_message = form.message.trim();

        if (username === '' || user_email === '' || user_message === '') {
            setLoading(false);
            toast.error("Please fill all the fields.", {
                position: 'bottom-right',
            });
            return;
        }

        emailjs
            .send(
                EMAIL_JS_SERVICE_ID,
                EMAIL_JS_TEMPLATE_ID,
                {
                    from_name: username,
                    to_name: "Avinash Ranga",
                    reply_to: user_email,
                    to_email: "coolcracker805@gmail.com",
                    message: user_message,
                },
                EMAIL_JS_PUBLIC_KEY
            )
            .then(
                () => {
                    setLoading(false);
                    toast.success("Message sent successfully!", {
                        position: 'bottom-right',
                    });
                    setForm({
                        name: "",
                        email: "",
                        message: "",
                    });
                },
                (error) => {
                    setLoading(false);
                    console.error(error);
                    toast.error("Uh, oh! Something went wrong. Please try again later.", {
                        position: 'bottom-right',
                    });
                }
            );
    };

    return (
        <div className='flex flex-col min-h-screen bg-black relative'>
            <div className='absolute inset-0 z-0'>
                <LiquidEther
                    colors={['#5227FF', '#FF9FFC', '#B19EEF']}
                    mouseForce={30}
                    autoSpeed={0.4}
                    viscous={25}
                    autoIntensity={2.5}
                    className="w-full h-full"
                />
            </div>
            
            <svg style={{ display: 'none' }}>
                <filter id="glass-distortion-contact">
                    <feTurbulence type="turbulence" baseFrequency="0.008" numOctaves="2" result="noise" />
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="77" />
                </filter>
            </svg>

            <div className='flex-1 flex items-center justify-center text-white pt-20 sm:pt-28 relative z-10'>
                <div ref={contactRef} className='glass-contact'>
                    <div className='glass-contact-inner'>
                        <div className='glass-filter'></div>
                        <div className='glass-distortion-overlay'></div>
                        <div className='glass-overlay'></div>
                        <div className='glass-specular'></div>
                        <div className='glass-content'>
                            <div className='text-center mb-8'>
                                <p className='text-lg font-light text-gray-400 mb-2'>REACH OUT TO ME</p>
                                <h2 className='text-4xl sm:text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 via-pink-500 to-purple-600'>
                                    Contact.
                                </h2>
                            </div>
                            <form
                                ref={formRef}
                                onSubmit={handleSubmit}
                                className='flex flex-col gap-8'
                            >
                                <label className='flex flex-col'>
                                    <span className='font-medium mb-4 text-gray-300'>Your Name</span>
                                    <input
                                        type='text'
                                        name="name"
                                        value={form.name}
                                        onChange={handleChange}
                                        placeholder="What's your name?"
                                        className='contact-input'
                                    />
                                </label>
                                <label className='flex flex-col'>
                                    <span className='font-medium mb-4 text-gray-300'>Your email</span>
                                    <input
                                        type='email'
                                        name="email"
                                        value={form.email}
                                        onChange={handleChange}
                                        placeholder="What's your web address?"
                                        className='contact-input'
                                    />
                                </label>
                                <label className='flex flex-col'>
                                    <span className='font-medium mb-4 text-gray-300'>Your Message</span>
                                    <textarea
                                        rows={7}
                                        name="message"
                                        value={form.message}
                                        onChange={handleChange}
                                        placeholder='What you want to say?'
                                        className='contact-input'
                                    />
                                </label>

                                <button
                                    type='submit'
                                    className='submit-button'
                                    disabled={loading}
                                >
                                    {loading ? "Sending..." : "Send"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer />
            <Footer />
        </div>
    );
};

export default Contact;
